(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.MainController = (function(superClass) {
    extend(MainController, superClass);

    function MainController(scope, transitions, modal) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.setLocale = bind(this.setLocale, this);
      this.editBackground = bind(this.editBackground, this);
      this.editContactInfo = bind(this.editContactInfo, this);
      MainController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.editContactInfo = this.editContactInfo;
      this.scope.editBackground = this.editBackground;
      this.scope.setLocale = this.setLocale;
      this.scope.editEmailPassOptions = {
        ngbModalOptions: {
          windowClass: 'extra-small-form'
        }
      };
      window.addEventListener('username.dropdown.contactInfo:save', (function(_this) {
        return function(event) {
          return _this.scope.user_name = event.detail.first_name + ' ' + event.detail.last_name;
        };
      })(this));
    }

    MainController.prototype.editContactInfo = function(additionalValidation) {
      if (additionalValidation == null) {
        additionalValidation = false;
      }
      return this.modal.open({
        windowClass: 'small_dialog',
        templateUrl: 'backend/username-dropdown/edit-contact-info',
        controller: 'UsernameDropdown.Controllers.ContactInfoController',
        resolve: {
          'userData': [
            'UsernameDropdown.Services.UserService', function(repo) {
              if (additionalValidation) {
                return repo.getSafelinkUser();
              } else {
                return repo.getLoggedInUser();
              }
            }
          ],
          'states': [
            'UsernameDropdown.Services.UserService', function(repo) {
              return repo.getStates();
            }
          ],
          'additionalValidation': function() {
            return additionalValidation;
          }
        }
      });
    };

    MainController.prototype.editBackground = function() {
      return this.modal.open({
        windowClass: 'medium_dialog',
        templateUrl: 'backend/username-dropdown/edit-background',
        controller: 'UsernameDropdown.Controllers.BackgroundController',
        resolve: {
          'userData': [
            'UsernameDropdown.Services.UserService', function(repo) {
              return repo.getLoggedInUser();
            }
          ],
          'backgroundOptions': [
            'UsernameDropdown.Services.UserService', function(repo) {
              return repo.getBackgroundOptions();
            }
          ]
        }
      });
    };

    MainController.prototype.setLocale = function() {
      return this.modal.open({
        windowClass: 'small_dialog',
        templateUrl: 'backend/username-dropdown/set-locale',
        controller: 'UsernameDropdown.Controllers.LocaleController',
        resolve: {
          'userData': [
            'UsernameDropdown.Services.UserService', function(repo) {
              return repo.getLoggedInUser();
            }
          ],
          'locales': [
            'UsernameDropdown.Services.UserService', function(repo) {
              return repo.getLocales();
            }
          ]
        }
      });
    };

    return MainController;

  })(Controller);

}).call(this);
